// extracted by mini-css-extract-plugin
module.exports = {"title":"Breadcrumbs_title__k32pK","link":"Breadcrumbs_link__kxfwu"};